export const teamConstants = {
  LOAD: "TC_LOAD",
};
